import { styled } from '@mui/material';
import { grey } from '@mui/material/colors';

export const SourceImportTypeInfoContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: 4,
});

export const SourceImportTypeInfoText = styled('span')({
  fontSize: 12,
  color: grey['400'],
});

export const SourceImportTypeInfoImage = styled('img')({
  width: 26,
  height: 19,
  marginRight: 4,
});

export const SourceImportTypeInfoFlexTypoText = styled('span')({
  fontSize: 14,
  color: '#00a650',
  fontStyle: 'italic',
  fontWeight: 'bold',
});
